import { SupportedCurrencyCodes } from '@r6digital/rapidstor-types/react/entities/Location'; 

export enum Action {
    MOVE_IN = 'move-in',
    RESERVATION_WITH_FEE = 'reservation-with-fee'
}

export enum Mode {
    PAYMENT = 'PAYMENT',
    SETUP = 'SETUP'
}

export enum PaymentStatus {
    CREATED = 'CREATED',
    PENDING = 'PENDING',
    PAID = 'PAID',
    EXECUTED = 'EXECUTED',
    SETUP = 'SETUP',
}

export enum NextAction {
    REDIRECT_TO_URL = 'redirect_to_url'
}

export interface CreatePaymentLinkPayload {
    action: Action;
    amount: number;
    payment_details: {
        description: string;
        external_transaction_reference: string;
    };
    sender: {
        email: string;
        name: string;
        external_user_id: string;
    };
    mode: Mode;
    payment_method: string;
    currency: SupportedCurrencyCodes;
    status: string;
    timestamp: Date;
    return_url: string;
    webhook_url: string;
    metadata: CreatePaymentLinkMetadata;
}

export interface CreatePaymentLinkMetadata {
    action: Action;
    originUrl: string;
    corp: string;
    site: string;
    channel: string;
    location: string;
    locationHash: string;
    tenant: string;
    tenantId: string;
    unique_reference_id: string;
    reservationId: string;
    frontend_url: string;
    payment_details: {
        description: string;
        external_transaction_reference: string;
    };
    return_url: string;
    payment_metadata: {
        sCorpCode: string;
        sLocationCode: string;
        friendlyName: string;
        SiteId: string;
        tenantId: string;
        unique_reference_id: string;
        channel: string;
        rapidstorTransactionId?: string;
    }
    webhook_url: string;
}

export interface CreatePaymentLinkResponse {
    payment_link_id: string;
    payment_id: string | null;
    unique_reference_id: string;
    status: PaymentStatus;
    payment_link: string;
    return_url: string;
    webhook_url: string;
    currency: SupportedCurrencyCodes;
    amount: number;
    metadata: CreatePaymentLinkMetadata;
    next_action: {
        type: NextAction;
        url: string;
    };
    created_at: Date;
    updated_at: Date;
    id: number;
}